// extracted by mini-css-extract-plugin
module.exports = {"addonItem":"Addon_addonItem__I1_Jd","addonItemAGD":"Addon_addonItemAGD__2Ei0u","addonTitle":"Addon_addonTitle__SohRr","addonTitleAGD":"Addon_addonTitleAGD__LlDJm"};